import { OutlinedInput } from '@mui/material'
import React from 'react'

// One box of the 6-digit verification code
const SingleDigitInput = ({ id, index, value, setValue, digitRef, next, prev, enter, onPaste, hasError }) => {

  function handleKeyDown(event) {
    if (/^[0-9]$/.test(event.key)) {
      event.preventDefault();
      setValue(event.key);
      next(index);
      return;
    }
    if (event.key === "Backspace") {
      event.preventDefault();
      if (value === "") {
        prev(index);
      } else {
        setValue("");
      }
      return;
    }
    if (event.key === "ArrowLeft") {
      prev(index, false);
      return;
    }
    if (event.key === "ArrowRight") {
      next(index);
      return;
    }
    if (event.key === "Enter") {
      enter();
      return;
    }
    // Block other printable keys (letters, space); leave Tab, shortcuts etc. alone
    if (event.key.length === 1 && !event.ctrlKey && !event.metaKey) {
      event.preventDefault();
    }
  };

  return (
    <OutlinedInput
      id={id}
      value={value}
      inputRef={digitRef}
      onChange={() => { }}
      onPaste={onPaste}
      inputProps={{
        maxLength: 1,
        inputMode: 'numeric',
        autoComplete: index === 0 ? 'one-time-code' : 'off',
        'aria-label': `Digit ${index + 1}`,
        style: { textAlign: 'center', padding: 0 },
      }}
      sx={{
        width: 52,
        height: 60,
        borderRadius: "12px",
        fontSize: 26,
        fontWeight: 600,
        color: "#0F172A",
        backgroundColor: value ? "#F8FAFC" : "#FFFFFF",
        "& input": { height: "100%", caretColor: "#137FEC" },
        "& .MuiOutlinedInput-notchedOutline": { borderColor: hasError ? "#FCA5A5" : "#CBD5E1" },
        "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: hasError ? "#F87171" : "#94A3B8" },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#137FEC", borderWidth: 1 },
        "&.Mui-focused": { boxShadow: "0 0 0 3px rgba(19, 127, 236, 0.15)" },
      }}
      onKeyDown={handleKeyDown}
    />
  )
}

export default SingleDigitInput
